import { createCompassProductHandler } from "./compass/compassProductHandler";
import { createTrinetraProductHandler } from "./trinetra/trinetraProductHandler";

const createProductHandlerRegistry = (deps) => {
	return {
		compass: createCompassProductHandler(deps),
		trinetra: createTrinetraProductHandler(deps),
	};
};

export default createProductHandlerRegistry;
